// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles-module--cards--2diu2","slider":"styles-module--slider--2Ysjn","container":"styles-module--container--1hi25"};